import { Entry } from '@services/core-services/models';

export const sortEntries = (
  firstArray: Entry[],
  secondArray: Entry[],
  sortOrder: string = 'id'
): Entry[] => {
  const idIndexMap = new Map(
    secondArray.map((image, index) => [image[sortOrder as keyof Entry], index])
  );
  return firstArray.sort(
    (a, b) =>
      (idIndexMap.get(a[sortOrder as keyof Entry]) || 0) -
      (idIndexMap.get(b[sortOrder as keyof Entry]) || 0)
  );
};
